import React from "react";
import "../Styles/Blogs.css";
import MBA from "../Images/MBA copy.png";
import Navbar from "./NavBar";

export default function BlogContent() {
  return (
    <div>
        <Navbar/>
      <section class="blogcontent-content">
        <div class="blogcontent-container">
          <h2>
            How one Webflow user grew his single person consultancy from $0-100K
            in 14 months?
          </h2>
          <img src={MBA}></img>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Faucibus
            et molestie ac feugiat sed lectus vestibulum mattis ullamcorper.
            Viverra maecenas accumsan lacus vel facilisis volutpat. Nam libero
            justo laoreet sit amet cursus. Consectetur lorem donec massa sapien.
            Leo a diam sollicitudin tempor. Tempus quam pellentesque nec nam
            aliquam sem et tortor consequat. Sed vulputate odio ut enim blandit
            volutpat. Amet luctus venenatis lectus magna fringilla urna
            porttitor. Nulla at volutpat diam ut venenatis tellus in metus
            vulputate. Eu volutpat odio facilisis mauris sit amet massa. Ut enim
            blandit volutpat maecenas. Scelerisque fermentum dui faucibus in
            ornare quam viverra orci sagittis. Sit amet mattis vulputate enim.
            Dolor purus non enim praesent elementum facilisis leo vel fringilla.
            A pellentesque sit amet porttitor eget dolor morbi non arcu. Turpis
            tincidunt id aliquet risus feugiat in ante. Adipiscing diam donec
            adipiscing tristique. Elementum integer enim neque volutpat ac.
            Pulvinar sapien et ligula ullamcorper malesuada proin libero. Enim
            praesent elementum facilisis leo vel fringilla. Fringilla phasellus
            faucibus scelerisque eleifend donec pretium. In dictum non
            consectetur a erat nam at lectus. Eget duis at tellus at urna. Et
            leo duis ut diam quam. Pellentesque habitant morbi tristique
            senectus et. Posuere ac ut consequat semper viverra nam libero justo
          </p>
        </div>
      </section>
    </div>
  );
}
